export const enum CrudOperation {
    Create = 'Create',
    Update = 'Update',
    Read = 'Read',
    Delete = 'Delete',
}